import uniq from "lodash/uniq";
import recordQueryStringUsage from "views/logic/queries/recordQueryStringUsage";
import {
  escape,
  addToQuery,
  formatTimestamp,
  predicate,
  concatQueryStrings,
  edgeClause
} from "views/logic/queries/QueryHelper";
import { updateQueryString } from "views/logic/slices/viewSlice";
import { selectQueryString } from "views/logic/slices/viewSelectors";
import fieldTypeFor from "views/logic/fieldtypes/FieldTypeFor";
import hasMultipleValueForActions from "views/components/visualizations/utils/hasMultipleValueForActions";
const toPredicate = (field, value, type) => predicate(field, type.type === "date" ? formatTimestamp(value) : escape(value));
const formatNewQuery = (oldQuery, field, value, type) => addToQuery(oldQuery, toPredicate(field, value, type));
const orClause = (values) => `(${concatQueryStrings(
  values.map(({ field, value, type }) => toPredicate(field, value, type)),
  { operator: "OR", withBrackets: false }
)})`;
const AddToQueryHandler = ({ queryId, field, value = "", type, contexts }) => async (dispatch, getState) => {
  const oldQuery = selectQueryString(queryId)(getState());
  const multipleValues = hasMultipleValueForActions(contexts);
  const valuesToAdd = uniq(
    multipleValues ? contexts.valuePath.map((path) => {
      const [pathField, pathValue] = Object.entries(path)[0];
      return { field: pathField, value: pathValue, type: fieldTypeFor(pathField, contexts == null ? void 0 : contexts.fieldTypes) };
    }) : [{ field, value, type }]
  );
  let newQuery;
  if (multipleValues && (contexts == null ? void 0 : contexts.valuePathOperator) === "EDGE") {
    newQuery = addToQuery(
      oldQuery,
      edgeClause(
        { field: valuesToAdd[0].field, value: valuesToAdd[0].value },
        { field: valuesToAdd[1].field, value: valuesToAdd[1].value }
      )
    );
  } else if (multipleValues && (contexts == null ? void 0 : contexts.valuePathOperator) === "OR") {
    newQuery = addToQuery(oldQuery, orClause(valuesToAdd));
  } else {
    newQuery = valuesToAdd.reduce(
      (prev, valueToAdd) => formatNewQuery(prev, valueToAdd.field, valueToAdd.value, valueToAdd.type),
      oldQuery
    );
  }
  await recordQueryStringUsage(newQuery, oldQuery);
  return dispatch(updateQueryString(queryId, newQuery));
};
export default AddToQueryHandler;
